import axiosInstance from '@/utils/api.js'

var state = {
  vodService: []
}

var getters = {
  VOD_SERVICE: (state) => {
    return state.vodService
  }
}

var mutations = {
  SET_VOD_SERVICE: (state, payload) => {
    state.vodService = payload || []
  }
}

var actions = {
  GET_VOD_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/vod?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_VOD_SERVICE', result.data)
    }
  },
  CREATE_VOD_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/vod', payload)
  },
  UPDATE_VOD_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/vod', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/vodServices.js